module.exports = __webpack_public_path__ + "europa-5_ir.jpg?57442b4725da484b30010c65df5a3f74";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5_ir.jpg
// module id = 389
// module chunks = 0